module.exports = __webpack_public_path__ + "static/media/twitter-promotion.f7029014.png";